<template>
    <Dialog
     ref="settingDialog"
     title="设置"
     width="550px"
     :destroy-on-close="false">
        <el-row>
            <el-col :span="12" class="video-view">
                <el-row>
                    <div id="stream" class="stream"></div>
                </el-row>
                <el-row>
                    <el-progress
                    :percentage="percentageNum" 
                    :show-text="false"></el-progress>
                </el-row>
            </el-col>
            <el-col :span="12">
                <el-row>
                    <span>摄像头</span>
                    <el-select v-model="cameasActive" placeholder="请选择" @change="changeVideo">
                        <el-option
                            v-for="(item, index) in cameras"
                            :key="index"
                            :label="item.label"
                            :value="item.deviceId">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <span>麦克风</span>
                    <el-select v-model="microphonesActive" placeholder="请选择" @change="changeAudio">
                        <el-option
                            v-for="(item, index) in microphones"
                            :key="index"
                            :label="item.label"
                            :value="item.deviceId">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <span>扬声器</span>
                    <el-select v-model="loudspeakerActive" placeholder="请选择" @change="changeloudspeaker">
                        <el-option
                            v-for="(item, index) in loudspeakers"
                            :key="index"
                            :label="item.label"
                            :value="item.deviceId">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row type="flex" justify="end">
                    <el-button type="primary" @click="onSubmit">确定切换</el-button>
                    <el-button @click="$refs.settingDialog.visible = false">取消</el-button>
                </el-row>
            </el-col>
        </el-row>
    </Dialog>
</template>
<script>
import Dialog from '@/components/dialog/dialog';
export default {
    components: {
        Dialog
    },
    props: [ 'cameraStream' ],
    data() {
        return {
            // cameraStream: null,
            stream: null,
            cameras: [], //摄像头列表
            cameasActive: "", //当前选中的摄像头
            attentionShow: 0, // 0: 初十状态、1：获取成功、2：获取失败
            microphones: [], //麦克风列表
            microphonesActive: "", //当前选中的麦克风
            microphonesInterval: "",
            percentageNum: 0, //输出音量
            screenShareShow: false, //分享
            loudspeakers: [], //扬声器列表
            loudspeakerActive: "",
            loudspeakerStatus: false,
        }
    },
    methods: {
        show() {
            this.$refs.settingDialog.visible = true;
            this.getCameras();
            console.log(this.cameraStream.getVideoTrack())
        },
        //检查摄像头
        getCameras() {
            this.stream = TRTC.createStream({
                audio: true,
                video: true
            });
            // 设置视频分辨率等参数
            this.stream.setVideoProfile('180p');
            this.stream.initialize().then(() => {
                this.attentionShow = 1;
                var localVideoWrapEl = document.getElementById('stream');
                if (!localVideoWrapEl) {
                    localVideoWrapEl = document.createElement('div');
                    localVideoWrapEl.id = 'screen';
                    localVideoWrapEl.style.width = '100%';
                    localVideoWrapEl.style.height = '100%';
                    document.querySelector("#videoBox").insertBefore(localVideoWrapEl, null);
                }
                // 本地流播放
                this.stream.play(localVideoWrapEl, {
                    muted: true
                });
                TRTC.getCameras().then((devices) => { 
                    console.log(devices)
                    this.cameras = devices;
                    this.cameasActive = devices[0].deviceId;
                })
                TRTC.getMicrophones().then((devices) => { 
                    this.microphones = devices;
                    this.microphonesActive = devices[0].deviceId;
                    this.$nextTick(() => {
                        this.getMicrophones()
                    })
                })
                TRTC.getSpeakers().then((devices) => { 
                    this.loudspeakers = devices;
                    this.loudspeakerActive = devices[0].deviceId;
                })
            }).catch((error) => {
                console.log(error)
                this.attentionShow = 2;
                // 本地流初始化失败
                // switch (error.name) {
                //     case 'NotReadableError':
                //     // 提示用户：暂时无法访问摄像头/麦克风，请确保当前没有其他应用请求访问摄像头/麦克风，并重试。
                //     break;
                //     default:
                //     console.error(error);
                //     break;
                // }
            })
        },
        //切换视频设置
        changeVideo(deviceId) {
            this.cameasActive = deviceId;
            this.stream.switchDevice('video', deviceId).then(() => {
                // camera切换成功
                console.log("camera切换成功")
            });
        },
        //检查麦克风
        getMicrophones() {
            clearInterval(this.microphonesInterval)
            this.microphonesInterval = setInterval(() => {
                this.percentageNum = this.stream.getAudioLevel() * 400 > 100? 100 : this.stream.getAudioLevel() * 400;
            }, 100);
        },
        //切换麦克风
        changeAudio(deviceId) {
            this.microphonesActive = deviceId;
            this.stream.switchDevice('audio', deviceId).then(() => {
                // camera切换成功
                console.log("audio 切换成功")
            });
        },
        //切换扬声器
        changeloudspeaker(deviceId) {
            this.loudspeakerActive = deviceId;
            this.stream.setAudioOutput(deviceId).then(() => {
                console.log("loudspeaker 切换成功")
            })
        },
        //扬声器检测
        handlerDeviceAudio(type) {
            if(type == 'play') {
                this.loudspeakerStatus = true;
                this.$refs.deviceAudio.play();
            } else {
                this.loudspeakerStatus = false;
                this.$refs.deviceAudio.pause();
            }
        },
        stopDeviceAudio() {
            this.$refs.deviceAudio.pause();
            if(this.type == 'teacher') {
                this.stepsActive++;
            } else {
                this.$emit('changeLiveCheck');
            }
        },
        onSubmit() {
            this.cameraStream.switchDevice('video', this.cameasActive).then(() => {
                // camera切换成功
                console.log("camera切换成功")
            });
            this.cameraStream.switchDevice('audio', this.microphonesActive).then(() => {
                // camera切换成功
                console.log("audio 切换成功")
            });
            this.cameraStream.setAudioOutput(this.loudspeakerActive).then(() => {
                console.log("loudspeaker 切换成功")
            })
            this.$refs.settingDialog.visible = false;
        },
    },
}
</script>
<style scoped>
.video-view {
    padding: 10px;
}
.el-row {
    padding: 10px 0;
}
.stream {
    width: 100%;
    height: 180px;
}
.el-select {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/classroom/components/settingsDialog.vue